export default "__VITE_ASSET__BhYo2xz7__"